import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinmumbai() {



const cardData =
{
  keyword: 'Ertiga On Rent in Mumbai',

  heading: 'Lotus Cab: Ertiga On Rent in Mumbai',

  headingDescription:
    "Lotus Cabs offers reliable and affordable Ertiga On Rent in Mumbai for airport transfers, corporate travel, family vacations, business meetings, weddings, sightseeing tours, pilgrimage journeys, outstation trips, hotel transfers, and one-way or round-trip bookings. The Maruti Suzuki Ertiga is an ideal MPV for families and small groups, offering spacious seating, excellent comfort, modern features, and ample luggage space for both city and long-distance travel. Driven by professional and experienced chauffeurs, our well-maintained Ertiga cabs ensure a safe, comfortable, and hassle-free journey. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Mumbai, and outstanding customer service, Lotus Cabs delivers a premium travel experience at an economical price.",

  top: 'Top Places to Visit in Mumbai with Ertiga Rental',

 topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most popular destinations for travelers renting an Ertiga from Mumbai. Whether you're visiting for business meetings, corporate events, educational purposes, family functions, medical appointments, or weekend holidays, the spacious and comfortable Ertiga provides an enjoyable highway journey with plenty of room for passengers and luggage."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of Maharashtra's most visited pilgrimage destinations, attracting millions of Sai Baba devotees throughout the year. Families and senior citizens prefer renting an Ertiga because of its comfortable seating, smooth ride quality, and generous luggage space, making the pilgrimage relaxing and convenient."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a favorite hill station known for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, and lush green valleys. Renting an Ertiga from Mumbai is an excellent choice for weekend getaways, family outings, and group trips, offering a comfortable journey through the scenic Mumbai–Pune Expressway and Western Ghats."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most scenic hill stations, famous for Venna Lake, strawberry farms, breathtaking viewpoints, waterfalls, and cool weather. The Ertiga offers comfortable seating and smooth highway performance, making it ideal for family vacations, sightseeing tours, and holiday road trips."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most loved beach destination, attracting families, couples, and groups for memorable holidays. Renting an Ertiga from Mumbai provides the perfect combination of affordability, comfort, spacious interiors, and luggage capacity, ensuring an enjoyable journey to North Goa and South Goa."
    },
    {
        title: "Nashik",
        description:
            "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, Ram Kund, Sula Vineyards, and religious tourism. Travelers frequently book an Ertiga from Mumbai for pilgrimage tours, vineyard visits, family outings, and business travel while enjoying a safe and comfortable highway journey."
    },
    {
        title: "Aurangabad (Chhatrapati Sambhajinagar)",
        description:
            "Aurangabad is home to the UNESCO World Heritage Sites of Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, Daulatabad Fort, and Bibi Ka Maqbara. The Ertiga is an excellent vehicle for heritage tours and family vacations, providing comfortable seating and sufficient luggage space for multi-day travel."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for the sacred Mahalaxmi Temple, Panhala Fort, Rankala Lake, and traditional Maharashtrian cuisine. Families and pilgrimage groups often rent an Ertiga from Mumbai for comfortable long-distance travel, making temple visits and sightseeing enjoyable throughout the journey."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a beautiful coastal destination known for Alibaug Beach, Kolaba Fort, Kashid Beach, beach resorts, and exciting water sports. The Ertiga is a practical choice for beach holidays, offering comfortable seating, ample luggage space, and a smooth ride for families and small groups traveling from Mumbai."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a picturesque destination on the Konkan coast, famous for Ganpatipule Temple, pristine beaches, Alphonso mango orchards, historic sea forts, and scenic coastal drives. Renting an Ertiga from Mumbai allows travelers to explore the Konkan region comfortably while enjoying a spacious, economical, and reliable vehicle for long-distance road trips."
    }
],

  "services": [
    {
      "name": "Ertiga On Rent in Mumbai",
      "description": "Book Ertiga on rent in Mumbai for affordable and comfortable 6–7 seater travel. Suitable for family trips, local sightseeing, corporate travel, and social events. CNG and petrol variants available for cost-efficient per km pricing. Transparent fare structure includes base rate, driver allowance, and toll details. Pickup available across Andheri, Bandra, Borivali, Thane, and Navi Mumbai."
    },
    {
      "name": "Ertiga Airport Cab Mumbai",
      "description": "Reliable Ertiga airport cab service for Mumbai Airport (T1 & T2) pickup and drop. Ideal for families and small groups with moderate luggage. Professional drivers ensure timely arrival and safe transfer."
    },
    {
      "name": "Ertiga Outstation Cab Mumbai",
      "description": "Comfortable Ertiga outstation cab from Mumbai to Pune, Nashik, Shirdi, Lonavala, Goa, and nearby destinations. Suitable for long-distance highway travel with fuel-efficient performance."
    },
    {
      "name": "Ertiga Corporate Cab Mumbai",
      "description": "Corporate Ertiga cab service offering professional chauffeur-driven travel for meetings, conferences, and airport transfers."
    },
    {
      "name": "Ertiga Wedding Cab Mumbai",
      "description": "Spacious and clean Ertiga rental for wedding events and family functions ensuring punctual service."
    },
    {
      "name": "Cheap Ertiga On Rent Mumbai",
      "description": "Budget-friendly Ertiga rental with competitive per km pricing suitable for economical city and outstation travel."
    },
    {
      "name": "Ertiga Cab Near Me Mumbai",
      "description": "Area-wise Ertiga cab availability in Andheri, Borivali, Bandra, Thane, Navi Mumbai, and surrounding areas."
    },
    {
      "name": "Mumbai to Pune Ertiga Cab",
      "description": "Popular intercity route from Mumbai to Pune available with one-way and round-trip Ertiga options."
    }
  ],

  "tableData": [
    ["Ertiga On Rent in Mumbai", "Ertiga Airport Cab Mumbai"],
    ["Ertiga Outstation Cab Mumbai", "Ertiga Corporate Cab Mumbai"],
    ["Ertiga Wedding Cab Mumbai", "Cheap Ertiga On Rent Mumbai"],
    ["Ertiga Cab Near Me Mumbai", "Mumbai to Pune Ertiga Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Affordable Per KM Pricing",
      "WhyChoosedescription": "Fuel-efficient CNG and petrol options reduce travel cost."
    },
    {
      "WhyChooseheading": "Spacious 6–7 Seater",
      "WhyChoosedescription": "Comfortable seating suitable for families and groups."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Experienced chauffeurs familiar with Mumbai traffic."
    },
    {
      "WhyChooseheading": "Airport Pickup Support",
      "WhyChoosedescription": "Reliable transfers to and from Mumbai Airport."
    },
    {
      "WhyChooseheading": "Local & Outstation Coverage",
      "WhyChoosedescription": "Available for city travel and intercity journeys."
    },
    {
      "WhyChooseheading": "Area-Wide Availability",
      "WhyChoosedescription": "Service across Andheri, Bandra, Borivali, Thane, Navi Mumbai."
    },
    {
      "WhyChooseheading": "Wedding & Corporate Travel",
      "WhyChoosedescription": "Suitable for events and professional travel needs."
    },
    {
      "WhyChooseheading": "24x7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for booking and fare inquiries."
    }
  ]
}












const faqData = [
  {
    question: 'Does Lotus Cab provide Ertiga on rent in Mumbai?',
    answer: 'Yes, Lotus Cab offers Ertiga on rent in Mumbai for local travel, airport transfers, corporate bookings, and outstation trips with professional drivers and clean vehicles.',
  },
  {
    question: 'What is the seating capacity of Ertiga?',
    answer: 'Ertiga comes with 6+1 and 7-seater configurations, making it ideal for family travel, small groups, and comfortable airport transfers in Mumbai.',
  },
  {
    question: 'What are the charges for Ertiga rental in Mumbai?',
    answer: 'Ertiga rental charges depend on trip type (local, airport, outstation), total kilometers, and duration. Lotus Cab provides transparent per km pricing with no hidden charges.',
  },
  {
    question: 'Can I book Ertiga for Mumbai airport pickup and drop?',
    answer: 'Yes, Lotus Cab provides reliable Ertiga airport pickup and drop services in Mumbai with timely arrival and luggage assistance.',
  },
  {
    question: 'Is Ertiga suitable for outstation travel from Mumbai?',
    answer: 'Yes, Ertiga is comfortable for long-distance travel from Mumbai due to its spacious seating, smooth performance, and good luggage capacity.',
  },
  {
    question: 'Do you provide Ertiga for corporate travel in Mumbai?',
    answer: 'Absolutely. Lotus Cab offers Ertiga rentals for corporate meetings, office transfers, and business travel with professional drivers.',
  },
  {
    question: 'Are toll and parking charges included in Ertiga fare?',
    answer: 'Toll, parking, and applicable taxes are charged separately as per actuals. Lotus Cab ensures complete pricing transparency before confirming the booking.',
  },
  {
    question: 'Can I rent Ertiga for multi-day trips from Mumbai?',
    answer: 'Yes, Lotus Cab offers flexible multi-day Ertiga rental packages for vacations, pilgrimage tours, and group travel.',
  },
  {
    question: 'Is 24/7 Ertiga rental service available in Mumbai?',
    answer: 'Yes, Lotus Cab operates 24/7 Ertiga rental service in Mumbai including early morning and late-night bookings.',
  },
  {
    question: 'How can I book Ertiga on rent in Mumbai with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, trip duration, and passenger details to receive instant fare information and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Mehta',
    feedback: 'Booked Ertiga with Lotus Cab in Mumbai for family airport transfer. Spacious car, smooth ride, and punctual service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Pooja Kulkarni',
    feedback: 'Very comfortable Ertiga rental in Mumbai. Clean vehicle and transparent pricing. Highly recommend Lotus Cab for group travel.',
    rating: 5,
  },
];















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];





const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Ertiga On Rent in Mumbai",
"image": "https://lotuscab.com/assets/images/ertiga-on-rent-mumbai.jpg",
"description": "Book Ertiga on Rent in Mumbai with Lotus Cab for spacious, comfortable, and affordable travel. Ideal for airport transfers, family trips, weddings, and outstation journeys. 6–7 seater AC SUV available 24x7 with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "9165"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹15/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/ertiga-on-rent-mumbai"
}
};












  return (
    <div>
    

<Helmet>
  <title>Ertiga On Rent in Mumbai | 7 Seater SUV Cab Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Ertiga on Rent in Mumbai with Lotus Cab for comfortable and affordable travel. 6–7 seater SUV cab for airport transfers, outstation trips, and family travel. AC cabs, professional drivers, and 24x7 service available."
/>

<meta
 name="keywords"
 content="Ertiga on Rent in Mumbai, Ertiga Cab Mumbai, Mumbai Ertiga Rental, Ertiga Taxi Mumbai, 7 Seater Cab Mumbai, SUV Cab Mumbai, Family Cab Mumbai, Airport Ertiga Cab Mumbai, Outstation Ertiga Cab Mumbai, Hire Ertiga Mumbai, Affordable Ertiga Cab Mumbai, Cheap Ertiga Rental Mumbai, Online Ertiga Cab Booking Mumbai, Lotus Cab Mumbai Ertiga, AC SUV Cab Mumbai, Best Ertiga Cab Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinmumbai;